import { Container } from "react-bootstrap";
import React from "react";
import '../css/general.css';
import { Stage, Layer } from "react-konva";
import useImage from 'use-image';
import config from "../etc/config.json";
import Road from "../race/Road";



function Sandbox(props) {
  const [baseImage] = useImage(config.DIR_ICONS + 'icons8-cyclist-top-view-100.png');

  return (<>
    <h2>Sandbox</h2>

    <Container className="my-1 border border-secondary">
      <Stage key={'rider-sandbox'} width={1500} height={400}>
        <Layer>
          <Road x={0} y={0} length={20} width={8} scale={50} riders={
            [
              { id: 1, name: 'Bobet', x: 0, y: 0, selectionMode: 'none', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 2, name: 'Posada', x: 1, y: 0, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 3, name: 'Golding', x: 0, y: 1, selectionMode: 'selected', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 4, name: 'RuizZafon', x: 1, y: 1, selectionMode: 'source', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 5, name: 'Tapies', x: 0.5, y: 2, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 6, name: 'Escalona', x: 1.5, y: 2, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 7, name: 'DelPicchia', x: 2.5, y: 2, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' }
            ]
          } />
        </Layer>
      </Stage>
    </Container>

    <Container className="my-1 border border-secondary">
      <Stage key={'rider-sandbox'} width={1500} height={400}>
        <Layer>
          <Road x={0} y={0} length={20} width={4} scale={30} riders={
            [
              { id: 1, name: 'Bobet', x: 0, y: 0, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 2, name: 'Posada', x: 1, y: 0, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 3, name: 'Golding', x: 0, y: 1, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 4, name: 'RuizZafon', x: 1, y: 1, selectionMode: 'source', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 5, name: 'Tapies', x: 0.5, y: 2, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 6, name: 'Escalona', x: 1.5, y: 2, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' },
              { id: 7, name: 'DelPicchia', x: 2.5, y: 2, selectionMode: 'target', image: config.DIR_JERSEYS + config.SUBDIR_USERJERSEYS + 'trikot_3341.png' }
            ]
          } />
        </Layer>
      </Stage>
    </Container>




  </>)
}

export default Sandbox;
